const CHUNK_RELOAD_SESSION_KEY = 'affilio-chunk-reload';

const CHUNK_LOAD_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Loading chunk [\d]+ failed/i,
  /Loading CSS chunk [\d]+ failed/i,
  /Importing a module script failed/i,
];

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return '';
}

export function isChunkLoadError(error: unknown): boolean {
  const message = getErrorMessage(error);
  if (!message) {
    return false;
  }
  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}

function tryRecoverFromChunkLoadError(error: unknown): void {
  if (!isChunkLoadError(error)) {
    return;
  }

  if (sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY)) {
    return;
  }

  sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, '1');
  window.location.reload();
}

/** Clears the one-time reload guard after a successful page load. */
export function clearChunkReloadGuard(): void {
  sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
}

/** Reload once when a stale bundle is requested after deployment (AFFILIO-PUBLISHER-PANEL-9). */
export function initChunkLoadRecovery(): void {
  clearChunkReloadGuard();

  window.addEventListener('error', (event) => {
    tryRecoverFromChunkLoadError(event.error ?? event.message);
  });

  window.addEventListener('unhandledrejection', (event) => {
    tryRecoverFromChunkLoadError(event.reason);
  });
}
